import { render, staticRenderFns } from "./starsBar.vue?vue&type=template&id=69813028&scoped=true&"
import script from "./starsBar.vue?vue&type=script&lang=js&"
export * from "./starsBar.vue?vue&type=script&lang=js&"
import style0 from "./starsBar.vue?vue&type=style&index=0&id=69813028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69813028",
  null
  
)

export default component.exports